import { useLayoutEffect } from 'react'

import Clarity from '@microsoft/clarity'
import { INNOSCRIPTA_INTERNAL_ORGANIZATION_ID } from 'shared/constants/user'

import { UseAnalyticsServiceHook } from '../analytics.types'

type ClarityFunction = (...args: unknown[]) => void

declare global {
  interface Window {
    clarity?: ClarityFunction
  }
}

const callClarity = (...args: unknown[]) => {
  if (typeof window === 'undefined') return
  if (typeof window.clarity !== 'function') return

  window.clarity(...args)
}

export const useClarity: UseAnalyticsServiceHook<'clarity'> = (
  user,
  config = { enabled: true, projectId: '' }
) => {
  useLayoutEffect(() => {
    if (!config.projectId) return

    if (!config.enabled) {
      callClarity('consent', false)
      callClarity('stop')
      return
    }

    Clarity.init(config.projectId)
    callClarity('consent', true)
  }, [config.enabled, config.projectId])

  useLayoutEffect(() => {
    if (!config.enabled || !config.projectId || typeof user?.id !== 'number')
      return

    const userType =
      user.organization_id === INNOSCRIPTA_INTERNAL_ORGANIZATION_ID
        ? 'internal'
        : 'external'

    Clarity.identify(`${user.id}`)
    Clarity.setTag('organization_id', `${user.organization_id}`)
    Clarity.setTag('user_type', userType)
  }, [user?.id, user?.organization_id, config.enabled, config.projectId])
}
